import { useState } from 'react'
import { Box } from '@mui/material'

import { SelectField } from 'components'
import type { SeoTaxonomyTag } from 'services'

const ALL = '__all'

export interface TagFilterState {
  industry: string
  solution: string
  product: string
}

/** The Industry / Solution / Product filter trio shared by Rankings and Gap finder. */
export const useTagFilters = () => {
  const [state, setState] = useState<TagFilterState>({ industry: ALL, solution: ALL, product: ALL })
  const matches = (r: { industries: string[]; solutions: string[]; products: string[] }) =>
    (state.industry === ALL || r.industries.includes(state.industry)) &&
    (state.solution === ALL || r.solutions.includes(state.solution)) &&
    (state.product === ALL || r.products.includes(state.product))
  const active = state.industry !== ALL || state.solution !== ALL || state.product !== ALL
  return { state, setState, matches, active }
}

export const TagFilters = ({
  taxonomy,
  state,
  onChange,
}: {
  taxonomy: SeoTaxonomyTag[]
  state: TagFilterState
  onChange: (s: TagFilterState) => void
}) => {
  const opts = (axis: SeoTaxonomyTag['axis'], all: string) => [
    { value: ALL, label: all },
    ...taxonomy.filter((t) => t.axis === axis).map((t) => ({ value: t.slug, label: t.label })),
  ]
  return (
    <Box
      sx={{
        display: 'grid',
        gap: '12px',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(3, minmax(0, 220px))' },
      }}
    >
      <SelectField
        value={state.industry}
        onChange={(v) => onChange({ ...state, industry: v as string })}
        options={opts('industry', 'All industries')}
      />
      <SelectField
        value={state.solution}
        onChange={(v) => onChange({ ...state, solution: v as string })}
        options={opts('solution', 'All solutions')}
      />
      <SelectField
        value={state.product}
        onChange={(v) => onChange({ ...state, product: v as string })}
        options={opts('product', 'All products')}
      />
    </Box>
  )
}
